import { Fragment } from 'react';
import { FaRegCalendar, FaMapMarkerAlt, FaStar, FaExternalLinkAlt } from 'react-icons/fa';
import { ImTicket } from 'react-icons/im';

const EventFullDetailsList = ({ event, isSearchResult }) => {
  return (
    <ul className="font-light ml-5 text-gray-500 text-sm leading-6 my-4">
      <li className="flex mb-4">
        <FaRegCalendar className="mt-1 mr-4" />
        {event.dateTimeRangeDesc}
      </li>
      <li className="flex mb-4">
        <FaMapMarkerAlt className="mt-1 mr-4" />
        <div className="flex flex-col">
          <div className="flex flex-row">
            {event.virtual && 'Virtual'}
            {!event.virtual && (
              <a
                className="inline focus:outline-none mr-4 text-theme-alt font-semibold"
                href={event.externalMapUrl}
                target="_blank"
                rel="noopener"
              >
                {event.venueName}
                <FaExternalLinkAlt className="inline-block text-theme-alt -mt-0.5 ml-1 text-xs" />{' '}
              </a>
            )}
          </div>
          <div className="text-xs">
            {event.venueAddressLines.map((line, index) => (
              <Fragment key={index}>
                {line}
                <br />
              </Fragment>
            ))}
          </div>
        </div>
      </li>
    </ul>
  );
};

export default EventFullDetailsList;
